// Exported constants shared across GA4 panels.
// Pure data — no React, no logic.

export const tooltipStyle = {
  backgroundColor: 'rgba(17, 24, 39, 0.85)',
  backdropFilter: 'blur(12px)',
  border: '1px solid rgba(255,255,255,0.1)',
  borderRadius: '8px',
  padding: '8px 12px',
  fontSize: '12px',
  color: '#f3f4f6',
  boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
};

export const DRILL_COLORS = ['#32B1FF', '#6366f1', '#f59e0b', '#10b981', '#ef4444', '#8b5cf6', '#ec4899', '#14b8a6'];

export const CHANNEL_COLORS = [
  '#32B1FF', '#8B5CF6', '#10B981', '#F59E0B', '#EF4444',
  '#EC4899', '#06B6D4', '#84CC16', '#F97316', '#6366F1',
];

export const TREND_METRICS = [
  { key: 'sessions', label: 'Sessions', color: '#32B1FF' },
  { key: 'users', label: 'Users', color: '#8B5CF6' },
  { key: 'conversions', label: 'Conversions', color: '#10B981' },
];

// Friendly names for common GA4 event names. Anything not in this map gets
// title-cased with underscores replaced — see humanizeEvent in format.js.
export const EVENT_LABELS = {
  page_view: 'Page View',
  session_start: 'Session Start',
  first_visit: 'First Visit',
  scroll: 'Scroll',
  click: 'Click',
  file_download: 'File Download',
  form_submit: 'Form Submit',
  form_start: 'Form Start',
  video_start: 'Video Start',
  video_progress: 'Video Progress',
  video_complete: 'Video Complete',
  view_search_results: 'View Search Results',
  purchase: 'Purchase',
  add_to_cart: 'Add to Cart',
  begin_checkout: 'Begin Checkout',
  generate_lead: 'Generate Lead',
  sign_up: 'Sign Up',
  login: 'Login',
  share: 'Share',
  select_content: 'Select Content',
  select_item: 'Select Item',
  view_item: 'View Item',
  view_item_list: 'View Item List',
  add_payment_info: 'Add Payment Info',
  add_shipping_info: 'Add Shipping Info',
  phone_click: 'Phone Click',
  user_engagement: 'User Engagement',
};
